class Venue {
    constructor({
        venueId = 0,
        active = false,
        name = '',
        city = '',
        country = '',
    }) {
        this.venueId = venueId
        this.active = active
        this.name = name
        this.city = city
        this.country = country
    }

    toJSON() {
        return {
            venueId: this.venueId,
            active: this.active,
            name: this.name,
            city: this.city,
            country: this.country,
        }
    }
}

export default Venue
